import styled from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Flex } from '@finect/tabular-core/Flex';
export var Inner = styled(Flex).withConfig({
  displayName: "partials__Inner",
  componentId: "sc-z6cvs3-0"
})(["padding:12px 0;"]);
export var Title = styled(AppLink).withConfig({
  displayName: "partials__Title",
  componentId: "sc-z6cvs3-1"
})(["font-size:18px;font-weight:700;line-height:27px;color:currentColor;&:hover{color:", ";text-decoration:underline;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.linkColor;
});
export var IconBlock = styled.div.withConfig({
  displayName: "partials__IconBlock",
  componentId: "sc-z6cvs3-2"
})(["position:relative;flex-shrink:0;width:56px;height:56px;border-radius:50%;margin-right:18px;background-color:", ";color:", ";text-align:center;svg{position:absolute;top:6px;right:5px;vertical-align:middle;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.accent1LL;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
});